/* @flow */

import React from 'react';
import { Segment, Form, Checkbox } from 'semantic-ui-react';

type Props = {
  content: CatalogPageContent,
  onSerialize?: (content: CatalogPageContent) => void,
};

const Edit = ({ content, onSerialize }: Props) => {
  const onTitleChange = (evt: SyntheticEvent) => {
    if (evt.target instanceof HTMLInputElement) {
      onSerialize({ ...content, title: evt.target.value });
    }
  };

  const onUrlChange = (evt: SyntheticEvent) => {
    if (evt.target instanceof HTMLInputElement) {
      onSerialize({ ...content, url: evt.target.value });
    }
  };

  const onExternalChange = (evt: SyntheticEvent, data: Object) => {
    if (evt.target instanceof HTMLElement) {
      onSerialize({ ...content, external: data.checked });
    }
  };

  return (
    <Segment>
      <Form>
        <Form.Field>
          <label>Titre</label>
          <input value={content.title || ''} onChange={onTitleChange} />
        </Form.Field>
        <Form.Field>
          <label>Url</label>
          <input value={content.url || ''} onChange={onUrlChange} />
        </Form.Field>
        <Form.Field>
          <Checkbox
            label="Action externe"
            checked={content.external}
            onChange={onExternalChange}
          />
        </Form.Field>
      </Form>
    </Segment>
  );
};

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/web/Edit.js